<template>
  <report-section title="血氧分析">
    <template v-slot:content>
      <div class="section-blood-oxygen">
        <section-trend-chart-template-hn v-if="reportDetailModel.xyReportTemplateType === 3"
          :reportDetailModel="reportDetailModel"></section-trend-chart-template-hn>
        <div class="section-blood-oxygen-content section-blood-oxygen-content-mt">
          <div class="section-blood-oxygen-content-column blood-oxygen-analysis-section">
            <div class="blood-oxygen-section-title">血氧统计</div>

            <key-value-unit title="平均血氧饱和度" :value="reportDetailModel.averageBloodOxygen"></key-value-unit>

            <div class="spacing-40"></div>

            <div class="custom-blood-oxygen-under-90">
              <p class="custom-key">血氧饱和度&lt;90%：</p>
              <p class="custom-value">{{ reportDetailModel.bloodOxygenUnder90TimeStr }}</p>
            </div>
            <key-value-unit title="Ts90%" :value="reportDetailModel.bloodOxygenUnder90RatioStr"></key-value-unit>

            <div class="spacing-40"></div>

            <key-value-unit title="最低血氧饱和度" :value="reportDetailModel.minBloodOxygen"></key-value-unit>
          </div>
          <section-blood-oxygen-table :reportDetailModel="reportDetailModel"></section-blood-oxygen-table>
          <section-blood-oxygen-chart :reportDetailModel="reportDetailModel"></section-blood-oxygen-chart>
          <div>

          </div>
        </div>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

import SectionBloodOxygenTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-blood-oxygen-table.vue";
import SectionBloodOxygenChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-blood-oxygen-chart.vue";
import SectionTrendChartTemplateHn from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-chart-template-hn.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
    SectionBloodOxygenTable,
    SectionBloodOxygenChart,
    SectionTrendChartTemplateHn,
  },

  props: {
    reportDetailModel: Object,
  },
};
</script>

<style lang="scss" scoped>
.blood-oxygen-analysis-section {
  /deep/ .blood-oxygen-section-title {
    color: #000000 !important;
    font-size: 18px !important;
    font-weight: bold !important;
    margin-top: -46px !important;
    margin-bottom: 20px !important;

  }
}

.spacing-40 {
  height: 40px;
}

/deep/.section-blood-oxygen-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .key-value-unit {
    min-width: 250px;
  }
}

.custom-blood-oxygen-under-90 {
  color: black;
  font-size: 16px;
  height: 20px;
  display: flex;
  align-items: center;
  min-width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-key {
  height: 100%;
  min-width: 60px;
  font-weight: normal;
  color: #000;
  margin: 0;
}

.custom-value {
  height: 100%;
  white-space: nowrap;
  margin: 0;
}

.section-blood-oxygen-content-mt {
  margin-top: -50px;
}

@media print {
  .blood-oxygen-analysis-section {
    /deep/ .blood-oxygen-section-title {
      color: #000000 !important;
      font-size: 16px !important;
      font-weight: bold !important;
      margin-top: -46px !important;

    }
  }

  .report-section {
    margin-top: 0 !important;
  }

  .section-blood-oxygen-content-mt {
    margin-top: 0 !important;
  }
}
</style>